import React from 'react'
import {
  CombinedListingType,
  useListingContext,
} from '../../../context/listing'
import AuctionDetailsTemplate from '../template'
import SparkOfferButton from '../../../components/sparkOfferButton'
import { getERVRow } from './common'

const detailContent = (
  listing: CombinedListingType,
  isRedesignEnabled: boolean
) => {
  const ervRow = getERVRow(listing, isRedesignEnabled)
  const details = ervRow ? [ervRow] : []

  return details
}

export const SparkOfferDetails = ({
  isRedesignEnabled,
}: {
  isRedesignEnabled: boolean
}) => {
  const { listing } = useListingContext()
  return (
    <AuctionDetailsTemplate
      title='SparkOffer Listing'
      primaryButton={<SparkOfferButton elmId='spark_offer_link' />}
      detailContent={detailContent(listing, isRedesignEnabled)}
    />
  )
}
